"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modal = require("@jsluna/modal");

var _grid = require("@jsluna/grid");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Modal = function Modal(props) {
  var isOpen = props.isOpen,
      handleClose = props.handleClose;
  return /*#__PURE__*/_react.default.createElement(_modal.Modal, {
    className: "ln-u-hard",
    small: true,
    handleClose: handleClose,
    open: isOpen,
    headingId: "info-modal"
  }, /*#__PURE__*/_react.default.createElement(_modal.ModalHeading, {
    element: "h4"
  }, "Only use this option for the following reasons"), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      xs: '1/1'
    }
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "c-text-arial"
  }, /*#__PURE__*/_react.default.createElement("li", null, "BFPO address"), /*#__PURE__*/_react.default.createElement("li", null, "Non-UK address"), /*#__PURE__*/_react.default.createElement("li", null, "Refused to give address"))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      xs: '1/1'
    }
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: "ln-u-flush-bottom c-text-arial-bold"
  }, "Use of this tick-box will be monitored"))));
};

Modal.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  handleClose: _propTypes.default.func.isRequired
};
var _default = Modal;
exports.default = _default;